import { ICreateChecklistServicoAmbienteUseCase } from "../../../presentation/useCases/create/create_checklist_servico_ambiente_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateChecklistServicoAmbienteUseCase
 */

export class CreateChecklistServicoAmbienteUseCase implements ICreateChecklistServicoAmbienteUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async execute(
    idChecklistServico: number,
    descricao?: string,
    ordem?: string,
  ): Promise<number> {
    const idChecklistServicoAmbiente = await this.repository.createChecklistServicoAmbiente(
      idChecklistServico,
      descricao,
      ordem);

    return idChecklistServicoAmbiente;
  }
}
